import $ from 'jquery';

const kDismissedMessages = 'systemMessagesDismissed'; // will be string[]

/**
 * @param msg can include basic HTML; is rendered inside `div.alert.alert-warning`
 * @returns
 */
export function handleSystemMessage(msg: string) {
  if (msg) {
    displaySystemMessage(msg);
  } else {
    dismissSystemMessage(''); // doesn't matter, we're gonna nuke it anyway
    localStorage.removeItem(kDismissedMessages);
    return;
  }
}

async function displaySystemMessage(msg: string) {
  try {
    const msgHash = await getSHA256Hash(msg)
    if (getDismissedMessages().includes(msgHash)) {
      return;
    }
    const msgDiv = $(`
      <div class="alert alert-warning alert-dismissible alert-system w-100 mb-0 rounded-0" role="alert">
        <div>${msg}</div>
        <button type="button" class="btn-close" aria-label="Close"></button>
      </div>
    `);
    $(msgDiv).find('.btn-close').on('click', () => dismissSystemMessage(msgHash));
    $('#header').append(msgDiv);
  } catch (e) {
    // silently ignore... sadness
  }
}

function dismissSystemMessage(msgHash: string) {
  $('#header .alert-system').remove();
  const dismissed = getDismissedMessages();
  dismissed.push(msgHash);
  localStorage.setItem(kDismissedMessages, JSON.stringify(dismissed));
}

function getDismissedMessages(): string[] {
  return JSON.parse(localStorage.getItem(kDismissedMessages) || '[]');
}

async function getSHA256Hash(msg: string) {
  const buf = new TextEncoder().encode(msg);
  const hashBuffer = await window.crypto.subtle.digest("SHA-256", buf);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hash = hashArray
    .map((item) => item.toString(16).padStart(2, "0"))
    .join("");
  return hash;
}
